import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path, Rect } from "react-native-svg";

export const IconVoiceMode: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconVoiceMode"><Path d="M21.25 8.95833V11.0417M17.75 3.75V16.25M14.25 6.875V10.2188M10.75 4.79167V8.91667" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/><Rect x="2.25" y="12.25" width="12" height="8" rx="4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/><Circle cx="6.25" cy="16.25" r="1.75" fill="currentColor"/></CentralIconBase>;
});

export default IconVoiceMode;
